import script from "./TableLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableLoader.vue?vue&type=script&setup=true&lang=ts"

import "./TableLoader.vue?vue&type=style&index=0&id=e0d9f29a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0d9f29a"]])

export default __exports__